import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIResponse } from '@yourcause/common';
import { TokenResponse } from '../../typings/token.typing';
import { lastValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TokenRetrievalResources {

  constructor (
    private httpRestService: HttpClient
  ) { }

  async getPlatformAdminToken (
    code: string,
    clientIdentifier: string
  ): Promise<TokenResponse> {
    const endpoint = 'api/admin/Sso/Token';

    const result = await lastValueFrom(this.httpRestService.post<APIResponse<TokenResponse>>(endpoint, {
      code,
      clientIdentifier
    }));

    return result.data;
  }
}

